import CreateSurveyButton from "@pulse/features/dashboard/DashboardHeader/CreateSurveyButton";
import SurveyTable from "@pulse/features/dashboard/SurveyTable/SurveyTable";
import usePulseId from "@pulse/hooks/usePulseId";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeaderBack } from "frontend-components";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_hub/$customerId/pulse/$pulseId/_surveyList/surveys")({
    component: RouteComponent,
    staticData: {
        titleFn: (t) => t("title.allSurveys"),
    },
});

function RouteComponent() {
    const { t } = useTranslation();
    const pulseId = usePulseId();

    return (
        <>
            <PageHeaderBack>
                <Link
                    to="/$customerId/pulse/$pulseId"
                    from="/$customerId"
                    params={{ pulseId: String(pulseId) }}
                    className="group text-text-secondary inline-flex items-center gap-2 self-start text-sm hover:underline"
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        className="text-compendia-greige group-hover:text-compendia-foreground size-4 transition-all duration-300 ease-out group-hover:-translate-x-1"
                    />
                    {t("survey.backToOverview")}
                </Link>
            </PageHeaderBack>
            <CreateSurveyButton />
            <SurveyTable pulseInstanceId={pulseId} />
        </>
    );
}
